/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Price_Page_Faq_Cancel_AInputs */

const en_price_page_faq_cancel_a = /** @type {(inputs: Price_Page_Faq_Cancel_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel the visit in your bookings. Up to the time the specialist has set, it is free. After that, part of the price may stay with the specialist, as shown when you book.`)
};

const pl_price_page_faq_cancel_a = /** @type {(inputs: Price_Page_Faq_Cancel_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odwołujesz wizytę w swoich rezerwacjach. Do terminu, który ustalił specjalista, bez opłat. Po nim część ceny może zostać u specjalisty, tak jak widzisz to przy rezerwacji.`)
};

/**
* | output |
* | --- |
* | "Cancel the visit in your bookings. Up to the time the specialist has set, it is free. After that, part of the price may stay with the specialist, as shown wh..." |
*
* @param {Price_Page_Faq_Cancel_AInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const price_page_faq_cancel_a = /** @type {((inputs?: Price_Page_Faq_Cancel_AInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Price_Page_Faq_Cancel_AInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_price_page_faq_cancel_a(inputs)
	return en_price_page_faq_cancel_a(inputs)
});